import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "staff-list" }
const _hoisted_2 = {
  key: 0,
  class: "border-top my-3"
}
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "avatar avatar-xl avatar-circle mb-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "avatar-img",
  src: "https://htmlstream.com/preview/front-v4.3.1/assets/img/160x160/img1.jpg"
}
const _hoisted_7 = { class: "card-subtitle text-capitalize" }
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi-envelope" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "container justify-content-center text-center p-7 ps-0 pe-0",
  style: {"opacity":"0.7"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitCard = _resolveComponent("MrUiKitCard")!
  const _component_MrUiKitList = _resolveComponent("MrUiKitList")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.staffs.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.staffs.length)
      ? (_openBlock(), _createBlock(_component_InfiniteScroll, {
          key: 1,
          guard: _ctx.guard,
          rowClasses: ['d-flex'],
          isLoading: _ctx.isLoading,
          onLoad: _ctx.loadMore
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.t('common.staff')), 1)
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.staffs.length)
              ? (_openBlock(), _createBlock(_component_MrUiKitList, {
                  key: 0,
                  classes: ['mb-4'],
                  columns: 4,
                  items: _ctx.staffs
                }, {
                  default: _withCtx(({ item }) => [
                    _createVNode(_component_MrUiKitCard, {
                      classes: ['h-100'],
                      footerClasses: ['pt-0']
                    }, _createSlots({
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          (item.photo)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "avatar-img",
                                src: item.photo.url
                              }, null, 8, _hoisted_5))
                            : (_openBlock(), _createElementBlock("img", _hoisted_6))
                        ]),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(item.staffRole.name), 1),
                        _createElementVNode("h4", _hoisted_8, _toDisplayString(item.fullname), 1)
                      ]),
                      _: 2
                    }, [
                      (item.email)
                        ? {
                            name: "footer",
                            fn: _withCtx(() => [
                              (item.email)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.sendEmail(item.email)),
                                    target: "_blank",
                                    class: "btn btn-soft-secondary btn-xs btn-icon rounded-circle"
                                  }, _hoisted_11, 8, _hoisted_9))
                                : _createCommentVNode("", true)
                            ])
                          }
                        : undefined
                    ]), 1024)
                  ]),
                  _: 1
                }, 8, ["items"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.t("common.noStaffs")), 1))
          ]),
          _: 1
        }, 8, ["guard", "isLoading", "onLoad"]))
      : _createCommentVNode("", true)
  ]))
}